export const ERROR_5XX_TOASTER = 'Unexpected error received. Our team is currently looking into this.';
export const ERROR_403_TOASTER = 'You do not have access to this.';

export const UNSIGNED_ERROR = 'Authentication credentials were not provided.';
export const MAX_FILE_SIZE_ERROR = 'Upload file size limit is 4.2MB';

export const NYLAS_INVALID_CREDENTIALS = 'nylas_invalid_credentials';
export const NYLAS_SYNC_ERROR = 'nylas_sync_error';
export const IMAP_VERIFICATION_FAIL = 'imap_verification_fail';
export const NYLAS_ACCOUNT_INVALID = 'nylas_account_invalid';
export const NYLAS_ERROR_MESSAGES = {
  [NYLAS_INVALID_CREDENTIALS]: 'Invalid password.',
  [NYLAS_SYNC_ERROR]: 'Sync error, please hit reconnect. If error persists contact support.',
  [IMAP_VERIFICATION_FAIL]: 'Invalid IMAP settings, ensure IMAP is enabled correctly.',
  [NYLAS_ACCOUNT_INVALID]: 'Invalid settings. Verify your settings.',
};
export const NYLAS_ERRORS = Object.keys(NYLAS_ERROR_MESSAGES);
